import {
  DAMNodeType,
  type TreeRecursiveChildrenNode,
  getTreeBranchNodeResponseSchema,
  getTreeRootNodeResponseSchema,
  moveNodesResponseSchema,
  treeRecursiveChildrenNodeSchema,
} from '@/types/tree';
import { INTERNAL_V1, damRequest } from '@/hooks/damRequest';

const BASE = `${INTERNAL_V1}/tree`;

export const getRootNodes = async (params?: null, token?: string) => {
  const response = await damRequest('GET', BASE, token, {});
  return getTreeRootNodeResponseSchema.parse(response);
};

export const getNode = async (
  params: { nodeId: string; types?: string; includeChildren?: boolean },
  token?: string,
): Promise<TreeRecursiveChildrenNode> => {
  const url = `${BASE}/${params.nodeId}?includeChildren=${params?.includeChildren ? '1' : '0'}`;
  const response = await damRequest('GET', url, token, {});

  if (params.includeChildren) {
    return treeRecursiveChildrenNodeSchema.parse(response);
  }

  return getTreeBranchNodeResponseSchema.parse(response);
};

export const getIdFromPath = async (params: { path: Array<string> }, token?: string) => {
  const response = await damRequest('POST', `${BASE}/path`, token, { body: params });
  return response;
};

export const moveNodesQuery = async (
  params?: Array<{ parentFolderNodeId?: string; nodes: Array<string> }>,
  token?: string,
) => {
  const response = await damRequest('POST', `${BASE}/move`, token, { body: { move: params } });
  return moveNodesResponseSchema.parse(response);
};

export const favoriteNode = async (params: { node_id: string }, token?: string) => {
  const response = await damRequest('POST', `${INTERNAL_V1}/nodes/${params.node_id}/favorite`, token);
  return response;
};

export const unfavoriteNode = async (params: { node_id: string }, token?: string) => {
  const response = await damRequest('DELETE', `${INTERNAL_V1}/nodes/${params.node_id}/favorite`, token);
  return response;
};

export const searchNodes = async (params: { search: string; type?: DAMNodeType }, token?: string): Promise<any> => {
  const trimmedSearch = params.search.trim();
  const query = new URLSearchParams({
    limit: '5000',
    offset: '0',
    filterQuery: trimmedSearch,
  });
  const typesParam = params.type ?? `${DAMNodeType.Album},${DAMNodeType.Folder}`;
  query.set('types', typesParam);

  const response = await damRequest('GET', `${BASE}?${query.toString()}`, token, {});

  return getTreeRootNodeResponseSchema.parse(response);
};
